import { render, staticRenderFns } from "./WarehouseTransfer__Detail.vue?vue&type=template&id=182fbcb8&scoped=true&"
import script from "./WarehouseTransfer__Detail.vue?vue&type=script&lang=js&"
export * from "./WarehouseTransfer__Detail.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseTransfer__Detail.vue?vue&type=style&index=0&id=182fbcb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182fbcb8",
  null
  
)

export default component.exports